namespace RioERP.Reports {
    export interface ShippingReportRow {
        Id?: number;
        OrderId?: number;
        OrderNumber?: string;
        OrderDate?: string;
        CustomerName?: string;
        CustomerEmail1?: string;
        CustomerEmail2?: string;
        CustomerMobile1?: string;
        CustomerMobile2?: string;
        ShippingAddress1?: string;
        ShippingAddress2?: string;
        ShippingCity?: string;
        ShippingPincode?: number;
        ShippingDate?: string;
        SourceType?: Web.Enums.SourceType;
        Status?: Web.Enums.ShippingStatus;
        ShippingProviderName?: string;
        TrackingId?: string;
        TrackingUrl?: string;
        ShippingProviderId?: number;
    }

    export namespace ShippingReportRow {
        export const idProperty = 'Id';
        export const nameProperty = 'OrderNumber';
        export const localTextPrefix = 'Reports.ShippingReport';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            Id = "Id",
            OrderId = "OrderId",
            OrderNumber = "OrderNumber",
            OrderDate = "OrderDate",
            CustomerName = "CustomerName",
            CustomerEmail1 = "CustomerEmail1",
            CustomerEmail2 = "CustomerEmail2",
            CustomerMobile1 = "CustomerMobile1",
            CustomerMobile2 = "CustomerMobile2",
            ShippingAddress1 = "ShippingAddress1",
            ShippingAddress2 = "ShippingAddress2",
            ShippingCity = "ShippingCity",
            ShippingPincode = "ShippingPincode",
            ShippingDate = "ShippingDate",
            SourceType = "SourceType",
            Status = "Status",
            ShippingProviderName = "ShippingProviderName",
            TrackingId = "TrackingId",
            TrackingUrl = "TrackingUrl",
            ShippingProviderId = "ShippingProviderId"
        }
    }
}
